// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"c7efb7a1","498":"4741aa50","703":"97cc1946","787":"05e7aa11"}[chunkId] + ".chunk.js";
};